import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import WhatsAppButton from '../components/WhatsAppButton'
import VidaCircle from '../assets/brand/vida-circle.webp'

const BlogLayout = ({
  category,
  title,
  children
}) => {
  return (
    <>
      <Helmet>
        <title>Vida Cowork: { title } - Artículo</title>
      </Helmet>

      <main className="Blog">
        <section className="Blog__Container container-custom">
          <div className="Blog__Header">
            <span className="text-orange text-2">{ category }</span>
            <span className="title-2 text-green">
              { title }
            </span>
            <div className="d-flex gap-2 align-items-center">
              <img src={VidaCircle} alt="Vida Circle" width={44} height={44} />
              <span className="text-5 text-gray-dark fw-bold">Vida Cowork</span>
            </div>
          </div>
          <div className="Blog__Content">
            { children }
          </div>
          <WhatsAppButton label="Probá un día gratis" withIconLeft />
        </section>
      </main>
    </>
  )
}

BlogLayout.propTypes = {
  category: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
}


export default BlogLayout